(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminUserAndBilling', {
                    requireLogin: true,
                    url: 'admin/userAndBillingOverview',
                    templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/userAndBillingOverview.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'userAndBillingOverview']
                    },
                    controller: 'userAndBillingOverviewCtrl'
                })
        }]);
})();